import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import ItemCount from '../ItemCount/ItemCount';
import { useCartContext } from '../Context/CartContext';
import DrinksDropdown from '../Drinks/DrinksDropdown';
import Dips from '../Dips/Dips';
import MedallonesDropdown from '../Extra/MedallonesDropdown';
import axios from 'axios';
import "../ItemDetail/ItemDetail.css";

const ItemDetail = ({ item }) => {
  const { 
    addProduct, selectedSize, setSelectedSize, selectedDrink, setSelectedDrink, 
    selectedDip, anotaciones, setAnotacion, precioExtra 
  } = useCartContext();

  const [formComplete, setFormComplete] = useState(false);
  const [precioExtras, setPrecioExtras] = useState(0);
  const [medallonesExtras, setMedallonesExtras] = useState(0);
  const [moduloBebida, setModuloBebida] = useState(false);
  const [acomp, setAcomp] = useState("");

  // 🔥 Calcular precio dinámico
  const calcularPrecio = () => {
    let basePrice = selectedSize === 'simple' ? item.simple : item.doble;
    let extraMedallones = medallonesExtras * (precioExtra?.extraPrice || 0);
    let bebidaPrice = selectedDrink?.precio || 0;
    return basePrice + extraMedallones + bebidaPrice;
  };

  useEffect(() => {
    setFormComplete(
      selectedSize !== '' &&
      acomp !== '' &&
      selectedDip !== '' &&
      (!moduloBebida || selectedDrink !== '')
    );
  }, [selectedSize, acomp, selectedDrink, selectedDip, anotaciones]);

  useEffect(() => {
    const obtenerEstadoModuloBebida = async () => {
      try {
        const response = await axios.get('https://pedir-prueba.p89nps.easypanel.host/phone');
        setModuloBebida(response.data.length > 0 && response.data[0].modulo_bebida === 1);
      } catch (error) {
        console.error("Error al obtener el estado del módulo de bebidas:", error);
      }
    };
    obtenerEstadoModuloBebida();
  }, []);

  const handleSizeChange = (event) => setSelectedSize(event.target.value);
  const handleMedallonesExtraChange = (value) => {
    setMedallonesExtras(value);
    setPrecioExtras(value * (precioExtra?.extraPrice || 0));
  };

  const onAdd = (quantity) => {
    addProduct(item, quantity, selectedSize, calcularPrecio(), acomp, selectedDrink, selectedDip, anotaciones, { medallones: medallonesExtras });
  };

  return (
    <Container className="mt-4 item-detail-container">
      {/* 🔥 Precio Fijo en la Esquina */}
      <div className="fixed-price-tag">💰 ${calcularPrecio()}</div>

      {/* 🔥 Imagen y Nombre */}
      <Row className="justify-content-center">
        <Col xs={12} md={6} className="text-center">
          <h3 className="item-title">{item.name}</h3>
          <img src={item.image} alt={item.name} className="img-fluid item-image" />
        </Col>
      </Row>

      {/* 🔥 Descripción */}
      <Row className="justify-content-center">
        <Col xs={12} md={8} className="text-center">
          <h5>📌 Descripción:</h5>
          <p>{item.description}</p>
        </Col>
      </Row>

      {/* 🔥 Opciones del Combo */}
      <Row className="justify-content-center mt-4">
        <Col xs={12} md={10}>
          <h5>🍔 Tamaño</h5>
          <Form.Check type="radio" label="Simple" name="size" value="simple" checked={selectedSize === 'simple'} onChange={handleSizeChange} />
          <Form.Check type="radio" label="Doble" name="size" value="doble" checked={selectedSize === 'doble'} onChange={handleSizeChange} />

          {/* 🔥 Acompañamiento */}
          <h5 className="mt-3">🍟 Acompañamiento</h5>
          <div className="acomp-container">
            <Button variant={acomp === "Papas fritas" ? "success" : "outline-light"} className="acomp-btn" onClick={() => setAcomp("Papas fritas")}>Papas Fritas</Button>
            <Button variant={acomp === "Aros de cebolla" ? "success" : "outline-light"} className="acomp-btn" onClick={() => setAcomp("Aros de cebolla")}>Aros de Cebolla</Button>
          </div>

          {/* 🔥 Salsa */}
          <h5 className="mt-3">🥫 Salsa</h5>
          <Dips />

          {/* 🔥 Bebida (si aplica) */}
          {moduloBebida && (
            <>
              <h5 className="mt-3">🥤 Bebida</h5>
              <DrinksDropdown />
            </>
          )}

          {/* 🔥 Medallones Extra */}
          <h5 className="mt-3">🍖 Medallones Extra</h5>
          <MedallonesDropdown onMedallonesExtraChange={handleMedallonesExtraChange} />

          {/* 🔥 Anotaciones */}
          <h5 className="mt-3">📝 Anotaciones</h5>
          <Form.Control as="textarea" placeholder="Ingrese anotaciones" value={anotaciones} onChange={(e) => setAnotacion(e.target.value)} />
        </Col>
      </Row>

      {/* 🔥 Precio y Botón de Añadir */}
      <Row className="justify-content-center mt-4">
        <Col xs={12} md={6} className="text-center">
{/*           <h3 className="price-text">💰 Precio: ${calcularPrecio()}</h3> */}
          <ItemCount stock={10} initial={1} onAdd={onAdd} disabled={!formComplete} />
        </Col>
      </Row>
    </Container>
  );
};

export default ItemDetail;
